<template>
  <div class="modal-inner-container">
    <div class="w-full">
      <div class="text-n-4xl font-bold">
        {{$t('security.twofa.backup_code')}}
      </div>
      
      <div class="text-n-md font-medium mt-n-5xl">
        {{$t('security.twofa.this_code_can_be_used')}}
      </div>

      <div class="flex items-center mt-n-4xl">
        <div class="secret-twofa">{{recovery}}</div>
        <input ref="backupCode" v-model="recovery" data-lpignore="true" data-testid="input-recovery" class="w-n-px opacity-0" readonly type="text" />
      </div>

      <div class="warning-container">
        {{$t('security.twofa.warning_if_you_lose_access')}}
      </div>
    </div>

    <div class="w-full mt-n-5xl">
      <ButtonV2
        @onClick="continueAction"
        :label="$t('continue')"
        testId="btn-continue"
        wide
      />
      <ButtonV2
        @onClick="copy"
        :label="$t('copy_to_clipboard')"
        testId="btn-copy"
        version="secondary"
        class="mt-n-2xl"
        wide
      />
    </div>
  </div>
</template>

<script>
  import ButtonV2 from '@/stories/misc/ButtonV2';

  export default {
    name: 'TwoFactorAuthenticationBackupCode',
    components: {
      ButtonV2,
    },

    async mounted() {
      await this.$store.dispatch('events/track', {
        event: 'TWO_FACTOR_ENABLE_BACKUP_KEY_VIEWED',
      });
    },

    data() {
      return {
        isLoading: false,
      };
    },
    props: {
      recovery: {
        type: String,
        required: true,
      },
    },
    methods: {
      copy() {
        const copyText = this.$refs.backupCode;

        copyText.select();
        copyText.setSelectionRange(0, 99999);

        document.execCommand('copy');

        this.showSuccess(this.$t('success.backup_code_copy'));
      },
      async continueAction() {
        this.showModal('VerifyAuthentication');
      },
    }
  };
</script>

<style scoped>
.secret-twofa {
  @apply flex-1 bg-background-page rounded-16 text-n-2xl font-semibold px-n-3xl py-n-2xl;
  overflow-wrap: anywhere;
}
</style>
